<section class="notification-item-container">
    <div class="notification-item-flex" fxLayout="column" (click)="markAsRead($event)"
        [ngClass]="{'notification-item-flex-unread': this.notificationService.getCurrentReceiver(notificationItem.notificationReceivers)?.status === 0}">
        <!-- <img src="./assets/images/notification_{{this.notificationService.getCurrentReceiver(notificationItem.notificationReceivers)?.status}}.png"
             alt="notification icon"
             class="notification-item-image"> -->
        <div class="notification-item-message">
            <div class="notification-item-header" fxLayoutAlign="space-between">
                <div>{{notificationItem.title?.en}}</div>
                <span class="notification-item-date">
                    {{this.notificationItem.createTime | date:'dd/MM HH:mm'}}
                </span>
            </div>
            <span class="notification-item-brief" innerHTML="{{notificationItem.content?.en}}">
            </span>
        </div>
        <span class="notification-item-detail-button" ngStyle.lt-lg="align-self: flex-start" (click)="openDetailDialog()">
        View More
    </span>
    </div>

</section>